export var InternationalFundingBusinessType;
(function (InternationalFundingBusinessType) {
    InternationalFundingBusinessType["COMPANY"] = "company";
    InternationalFundingBusinessType["INDIVIDUAL"] = "individual";
})(InternationalFundingBusinessType || (InternationalFundingBusinessType = {}));
